import { Text } from '@macarongfactory/web-ui'

import type { ComponentProps, ReactNode } from 'react'

interface ISectionHeadingProps {
  /** 제목 — 문자열 또는 JSX(예: 모델명 말줄임 + 접미어 고정 노출) */
  title: ReactNode
  label?: ReactNode
  /** 후기 수처럼 제목 옆에 강조 표기할 값 */
  highlight?: string
  /** 제목 타이포 variant (기본 body-1-semibold) */
  titleVariant?: ComponentProps<typeof Text>['variant']
  /** 강조값 타이포 variant (기본 body-1-semibold) */
  highlightVariant?: ComponentProps<typeof Text>['variant']
  /** 제목 Text 추가 클래스 (예: 'line-clamp-1'로 1줄 말줄임) */
  titleClassName?: string
  /** 라벨을 우측 끝으로 정렬 (제목·라벨 양끝 배치) */
  labelEnd?: boolean
}

/** 섹션 공통 제목 (제목 + 선택적 라벨/강조값) */
const SectionHeading = ({
  title,
  label,
  highlight,
  titleVariant = 'body-1-semibold',
  highlightVariant = 'body-1-semibold',
  titleClassName = '',
  labelEnd = false,
}: ISectionHeadingProps) => {
  return (
    <div
      className={
        labelEnd
          ? 'flex items-center justify-between gap-dimension-x2'
          : 'flex items-center gap-dimension-x2'
      }
    >
      <Text
        as='h2'
        variant={titleVariant}
        color='text-foreground-neutral-strong'
        className={`break-keep ${titleClassName}`}
      >
        {title}
        {highlight ? (
          <Text
            as='span'
            variant={highlightVariant}
            color='text-foreground-brand-strong'
          >
            {` ${highlight}`}
          </Text>
        ) : null}
      </Text>
      {label}
    </div>
  )
}

export default SectionHeading
